import React from "react";

import Text from "src/components/text";

import _ from "lodash";
import styles from "./leadsListItem.module.scss";
import { LeadItem } from "src/types/reports";
import cx from "classnames";
const DefaultAssetIcon = "/images/defaultIcons/default_asset.jpg";

interface LeadListItemProps {
  item: LeadItem;
  columnCount: number;
  onContactClick: (contactId: string) => void;
}

const LeadListItem: React.FC<LeadListItemProps> = ({
  item,
  columnCount,
  onContactClick,
}) => {
  const { firstName, lastName, asset, email, createdDate, company, id, utmCampaign } = item;
  const isCampaignPresent = _.size(utmCampaign?.name) > 0;
  return (
    <div key={id} className={styles.tableRow}>
      <div className={styles.tableDataContainer}>
        <img
          src={DefaultAssetIcon}
          className={styles.roundThumbnail}
          alt="Lead Icon"
        />
        <div className={styles.rightData}>
          <div className={styles.tableDataTitle}>
            <span
              className={styles.name}
              style={{ cursor: "pointer" }}
              onClick={() => onContactClick(id)}
            >
              {firstName || ""} {lastName || ""}
            </span>
          </div>
          <span className={styles.metricsData}>
            <span className={styles.name}>{email}</span>
          </span>
        </div>
      </div>
      <div
        className={styles.analyticsContainer}
        style={{
          gridTemplateColumns: `repeat(${columnCount}, minmax(0, 1fr))`,
        }}
      >
        <div className={styles.tableDataViews}>
          {new Date(createdDate).toLocaleDateString("en-GB", {
            day: "2-digit",
            month: "short",
            year: "numeric",
          })}
        </div>
        <div className={styles.tableDataShares}>{company}</div>
        <div className={styles.tableDataShares}>
            {asset ? (
            <a
              href={`/assets/${asset.id}?source=reports`}
              target="_blank"
              rel="noopener noreferrer"
              className={styles.linkWrapper}
            >
              <img
                src={asset.icon?.thumbnail || DefaultAssetIcon} 
                className={styles.thumbnailIcon}
                alt={asset.name || "Asset"}
              />
              <Text text={asset.name || ""} className={styles.name} lines={1} />
            </a>
          ) : (
            <p>N/A</p> 
          )}
        </div>
        <div className={cx(styles.tableDataShares,styles.leftAlign)}>
          {isCampaignPresent && <span className={styles.campaign}>campaign
          </span>}
            <Text text={utmCampaign?.name || "Direct"} className={cx(styles.campaignName, {
              [styles.campaignPresent]: isCampaignPresent,
            })}  lines={1} />
        </div>
      </div>
    </div>
  );
};

export default LeadListItem;
